import { useCallback, useEffect, useState } from 'react';
import { getCurrentAdmin } from '../services/adminAuthService';
import { getCurrentCustomer } from '../services/customerAuthService';

export const useNavigationIdentity = () => {
  const [identity, setIdentity] = useState({ status: 'loading', role: 'visitor', user: null });

  const refreshIdentity = useCallback(async () => {
      const admin = await getCurrentAdmin();
      if (admin.ok) return setIdentity({ status: 'ready', role: 'admin', user: admin.data });
      const customer = await getCurrentCustomer();
      if (customer.ok) return setIdentity({ status: 'ready', role: customer.data.entitlement === 'diy' ? 'diy' : 'free', user: customer.data });
      setIdentity({ status: 'ready', role: 'visitor', user: null });
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes('session_id=')) return undefined;
    refreshIdentity();
    window.addEventListener('tweeporter-auth-changed', refreshIdentity);
    return () => window.removeEventListener('tweeporter-auth-changed', refreshIdentity);
  }, [refreshIdentity]);

  return { ...identity, refreshIdentity };
};